import {initStore} from './store';

const configStore = () => {
    const actions = {
        SET_AUTHTOKEN: ( (curState, payload) => {
            if (null === payload) {
                localStorage.removeItem('token');
            }
            return {token: localStorage.getItem('token')};
        }),
        SET_AUTHTOKEN_ERZEUGER: ( (curState, payload) => {
            if (null === payload) {
                localStorage.removeItem('tokenErzeuger');
            }
            return {tokenErzeuger: localStorage.getItem('tokenErzeuger')};
        }),
        IS_401_ERROR: ( (curState, payload) => {
            return {is401Error: payload}
        }),
    };
    initStore(actions, {token: null, tokenErzeuger: null, is401Error:false});
}

export default configStore;
